module.exports = __webpack_public_path__ + "static/forestview-logo-947f3a9f4c871c1f884db41755de4078.jpg";